import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Button from "../buttons/buttons.js";
import { MENU } from "../../assets/images/pictures/images.js";
import { PIMAGE } from "../../assets/images/pictures/images";
import Category from "../../assets/images/emptyState/category-list.jpg";
import DarkCategory from "../../assets/images/emptyState/dark-category-list.png";
import Restaurant from "../../assets/images/emptyState/restaurant-list.jpg";
import DarkStore from "../../assets/images/emptyState/dark-store-list.png";
import ShippedIcon from "../../assets/images/icons/shipped.svg";

// function isBusinessHours(operating_hours) {
//   const daysOfWeek = [
//     "sunday",
//     "monday",
//     "tuesday",
//     "wednesday",
//     "thursday",
//     "friday",
//     "saturday",
//   ];

//   // Get today's date and time
//   const currentDatetime = new Date();
//   const currentDay = daysOfWeek[currentDatetime.getDay()];
//   const currentHour = currentDatetime.getHours();
//   const currentMinute = currentDatetime.getMinutes();

//   // Check if current time is within the operating hours for the current day
//   if (operating_hours?.hasOwnProperty(currentDay)) {
//     const { open, close } = operating_hours[currentDay];
//     const [openHour, openMinute] = open.split(":").map(Number);
//     const [closeHour, closeMinute] = close.split(":").map(Number);

//     const opensBeforeCurrentTime =
//       currentHour > openHour ||
//       (currentHour === openHour && currentMinute >= openMinute);
//     const closesAfterCurrentTime =
//       currentHour < closeHour ||
//       (currentHour === closeHour && currentMinute <= closeMinute);

//     return opensBeforeCurrentTime && closesAfterCurrentTime;
//   } else {
//     return false;
//   }
// }
function isBusinessHours(operating_hours, time_zone = "UTC+00:00") {
  const daysOfWeek = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];

  const now = new Date();

  let currentDay;
  let currentHour;
  let currentMinute;

  // Handle fixed UTC offsets such as:
  // UTC+00:00
  // UTC+01:00
  // UTC-05:00
  const utcOffsetMatch = time_zone?.match(
    /^UTC([+-])(\d{2}):(\d{2})$/
  );

  if (utcOffsetMatch) {
    const [, sign, hours, minutes] = utcOffsetMatch;

    const offsetMinutes =
      (Number(hours) * 60 + Number(minutes)) *
      (sign === "+" ? 1 : -1);

    // Get current UTC timestamp
    const utcTime = now.getTime() + now.getTimezoneOffset() * 60 * 1000;

    // Apply restaurant's UTC offset
    const restaurantTime = new Date(
      utcTime + offsetMinutes * 60 * 1000
    );

    currentDay = daysOfWeek[restaurantTime.getUTCDay()];
    currentHour = restaurantTime.getUTCHours();
    currentMinute = restaurantTime.getUTCMinutes();
  } else {
    // Handle IANA timezones such as:
    // Africa/Lagos
    // America/New_York
    // Europe/London
    try {
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: time_zone || "Africa/Lagos",
        weekday: "long",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
      });

      const parts = formatter.formatToParts(now);

      const weekday = parts.find(
        (part) => part.type === "weekday"
      )?.value?.toLowerCase();

      currentDay = weekday;
      currentHour = Number(
        parts.find((part) => part.type === "hour")?.value
      );
      currentMinute = Number(
        parts.find((part) => part.type === "minute")?.value
      );
    } catch (error) {
      console.error(
        "Invalid restaurant timezone:",
        time_zone
      );

      return false;
    }
  }

  // Check if the restaurant has operating hours for today
  if (!operating_hours?.hasOwnProperty(currentDay)) {
    return false;
  }

  const { open, close } = operating_hours[currentDay];

  if (!open || !close) {
    return false;
  }

  const [openHour, openMinute] = open.split(":").map(Number);
  const [closeHour, closeMinute] = close.split(":").map(Number);

  const currentTimeInMinutes = currentHour * 60 + currentMinute;
  const openTimeInMinutes = openHour * 60 + openMinute;
  const closeTimeInMinutes = closeHour * 60 + closeMinute;

  // Normal hours, e.g. 09:00 - 22:00
  if (closeTimeInMinutes >= openTimeInMinutes) {
    return (
      currentTimeInMinutes >= openTimeInMinutes &&
      currentTimeInMinutes <= closeTimeInMinutes
    );
  }

  // Overnight hours, e.g. 18:00 - 02:00
  return (
    currentTimeInMinutes >= openTimeInMinutes ||
    currentTimeInMinutes <= closeTimeInMinutes
  );
}



function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const Card = ({ children }) => {
  return (
    <div className="card" data-test="cardComponent">
      {children}
    </div>
  );
};

Card.Restaurants = ({
  title,
  tags,
  image,
  id,
  className,
  categories,
  operating_settings,
  operating_status,
  operating_hours,
  restaurant_time_zone,
  isDarkMode,
}) => {
  const onImageError = (e) => {
    e.target.src = isDarkMode ? DarkStore : Restaurant;
  };

  return (
    <div className="min-w-0">
      <div
        className={
          "w-full sm:w-full h-full bg-white dark:bg-[#121212] rounded-lg border dark:border-none rounded-b-xl cursor-pointer relative " +
          className
        }
        style={{
          boxShadow: '0px 0px 4px 0px #0000000F, 0px 2px 2px 0px #0000000F'
        }}
      >
        <Link to={`/restaurant/${id}`} className="h-full block min-w-0 overflow-visible">
          <div className="relative overflow-hidden rounded-t-lg">
            <img
              className="rounded-t-lg w-full h-[200px] object-cover"
              src={image ? image : isDarkMode ? DarkStore : Restaurant}
              onError={onImageError}
              alt="restaurant"
            />

            {(operating_status === "open" &&
              operating_settings === "available" &&
              operating_hours === null) ||
              (operating_status === "open" &&
                operating_settings === "available" &&
                operating_hours !== null &&
                isBusinessHours(operating_hours, restaurant_time_zone)) ? (
              ""
            ) : (
              <div className="absolute top-0 w-full h-full bg-gradient-to-b from-transparent to-black flex items-center z-10 rounded-t-lg">
                <p className="text-xl text-center font-bold text-white w-full">
                  Closed
                </p>
              </div>
            )}
          </div>

          {/* {categories?.length > 0 && (
            <div className="absolute top-6 left-6 w-auto rounded-lg inline-flex items-center bg-white p-2 shadow-md">
              <span className="text-[#4D4C4C] text-sm font-bold">
                {categories?.length > 0 && categories[0]}
              </span>
            </div>
          )} */}

          <div className="p-5 bg-white dark:bg-[#121212] rounded-b-xl min-w-0">
            <h5 className="mb-2 text-lg font-bold tracking-tight text-black dark:text-white capitalize">
              {title ?? "Title"}
            </h5>

            <div className="flex gap-2 overflow-x-auto scroll-smooth w-full min-w-0 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
              {tags?.length > 0 &&
                tags.map((tag, index) => (
                  <p
                    key={index}
                    className="flex-shrink-0 bg-[#F6F3F3] dark:bg-transparent dark:border dark:border-[#9CA3AF] rounded-md px-[10px] py-[4px] text-center text-[#4D4C4C] dark:text-[#BCBCBC] text-sm capitalize whitespace-nowrap"
                  >
                    {tag}
                  </p>
                ))}
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

Card.StoreCategories = ({ category, image, isDarkMode }) => {
  const onImageError = (e) => {
    e.target.src = isDarkMode ? DarkCategory : Category;
  };
  return (
    <Link to={`/user/store-category/${category?.name}`}>
      <div
        className={
          "w-full bg-white rounded-lg border border-gray-200 dark:border-none shadow-md"
        }
      >
        <div>
          <img
            className="w-full h-[200px] object-cover rounded-lg"
            src={category?.picture ?? Category}
            onError={onImageError}
            alt="categories"
          />
        </div>
      </div>
      <div className="my-4">
        <p className="text-lg font-semibold capitalize truncate">{category?.name ?? "category"}</p>
        {/* <p className=" text-sm text-[#FF725E] font-medium">
          {category?.found ?? "0"} found
        </p> */}
      </div>
    </Link>
  );
};

Card.Store = ({
  title,
  tags,
  id,
  image,
  categories,
  className,
  imageFallBack,
  operating_settings,
  operating_status,
  operating_hours,
  store_time_zone,
  isDarkMode,
}) => {
  const onImageError = (e) => {
    e.target.src = isDarkMode ? DarkStore : Restaurant;
  };
  return (
    <div className="min-w-0">
      <div
        className={
          "w-full sm:w-full bg-white dark:bg-[#121212] rounded-lg border dark:border-none rounded-b-xl cursor-pointer relative mb-2 " +
          className
        }
        style={{
          boxShadow: '0px 0px 4px 0px #0000000F, 0px 2px 2px 0px #0000000F'
        }}
      >
        <Link to={`/store/${id}`} className="h-full block min-w-0 overflow-visible">
          <div className="relative overflow-hidden rounded-t-lg">
            <img
              className="rounded-t-lg w-full h-[200px] object-cover"
              src={image ?? Restaurant}
              onError={onImageError}
              alt="store"
            />
            {(operating_status === "open" &&
              operating_settings === "available" &&
              operating_hours === null) ||
              (operating_status === "open" &&
                operating_settings === "available" &&
                operating_hours !== null &&
                isBusinessHours(operating_hours, store_time_zone)) ? (
              ""
            ) : (
              <div className="absolute top-0 w-full h-full bg-gradient-to-b from-transparent to-black flex items-center z-10 rounded-t-lg">
                <p className="text-xl text-center font-bold text-white w-full">
                  Closed
                </p>
              </div>
            )}
          </div>

          <div className="p-5 bg-white dark:bg-[#121212] rounded-b-xl min-w-0">
            <h5 className="mb-2 text-lg font-bold tracking-tight text-black dark:text-white capitalize">
              {title ?? "Title"}
            </h5>

            <div className="flex gap-2 overflow-x-auto scroll-smooth w-full min-w-0 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
              {tags?.length > 0 &&
                tags.map((tag, index) => (
                  <p
                    key={index}
                    className="flex-shrink-0 bg-[#F6F3F3] dark:bg-transparent dark:border dark:border-[#9CA3AF] rounded-md px-[10px] py-[4px] text-center text-[#4D4C4C] dark:text-[#BCBCBC] text-sm capitalize whitespace-nowrap"
                  >
                    {tag}
                  </p>
                ))}
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

Card.Categories = ({ category, isDarkMode }) => {
  const onImageError = (e) => {
    e.target.src = isDarkMode ? DarkCategory : Category;
  };
  return (
    <Link to={`/user/restaurant-category/${category?.name}`}>
      <div
        className={
          "w-full bg-white rounded-lg border border-gray-200 dark:border-none shadow-md"
        }
      >
        <div>
          <img
            className="w-full h-[160px] sm:h-[200px] object-cover rounded-lg"
            src={category?.picture ?? Category}
            onError={onImageError}
            alt="categories"
          />
        </div>
      </div>
      <div className="my-4">
        <p className="text-lg font-semibold capitalize truncate">{category?.name ?? "category"}</p>
        {/* <p className=" text-sm text-[#FF725E] font-medium">
          {category?.found ?? "0"} found
        </p> */}
      </div>
    </Link>
  );
};

Card.Menu = ({ title, image, className, amount, id, tags }) => {
  const onImageError = (e) => {
    e.target.src = Restaurant;
  };
  return (
    <div
      className={
        "w-full sm:w-full bg-white rounded-lg relative mb-2 flex" + className
      }
    >
      <Link to={`/store/${id}`}>
        <img
          className="rounded-t-lg w-full h-[200px] object-cover"
          src={image ?? MENU}
          onError={onImageError}
          alt="food"
        />

        {/* {tags?.length > 0 && (
          <div className="absolute top-6 left-6 w-auto rounded-lg inline-flex items-center bg-white p-2 shadow-md">
            <span className="text-[#4D4C4C] text-sm font-bold">
              {tags?.length > 0 && tags[0]}
            </span>
          </div>
        )} */}
        <div className="p-5 border bg-white rounded-b-xl">
          <div className="flex justify-between">
            <p className="mb-2 text-lg font-bold tracking-tight text-black">
              {title ?? "Title"}
            </p>
            <p className="text-lg font-meduim"> {amount ?? 0}</p>
          </div>
          {/* <div className="text-[#333333] text-sm font-normal tracking-tight mb-3">
          <p>{outlet ?? "outlet"}</p>
        </div> */}
        </div>
      </Link>
    </div>
  );
};

Card.MenuRestaurant = ({ title, image, className, amount, id, tags }) => {
  const onImageError = (e) => {
    e.target.src = Restaurant;
  };
  return (
    <div
      className={
        "w-full sm:w-full bg-white rounded-lg mb-2 relative flex" + className
      }
    >
      <Link to={`/restaurant/${id}`}>
        <img
          className="rounded-t-lg w-full h-[200px] object-cover"
          src={image ?? MENU}
          onError={onImageError}
          alt="food"
        />

        {/* {tags?.length > 0 && (
          <div className="absolute top-6 left-6 w-auto rounded-lg inline-flex items-center bg-white p-2 shadow-md">
            <span className="text-[#4D4C4C] text-sm font-bold">
              {tags?.length > 0 && tags[0]}
            </span>
          </div>
        )} */}
        <div className="p-5 border bg-white rounded-b-xl">
          <div className="flex justify-between">
            <p className="mb-2 text-lg font-bold tracking-tight text-black capitalize">
              {title ?? "Title"}
            </p>
            <p className="text-lg font-meduim">{amount ?? 0}</p>
          </div>
          {/* <div className="text-[#333333] text-sm font-normal tracking-tight mb-3">
          <p>{outlet ?? "outlet"}</p>
        </div> */}
        </div>
      </Link>
    </div>
  );
};

Card.OrderStatus = ({ order, track }) => {
  // let foodPreparationTime = order?.foods?.[0]?.food_preparation_time;
  let extraMinutes = 30;
  // const [prepHours, prepMinutes] = (foodPreparationTime || "00:00")
  //   ?.split(":")
  //   ?.map(Number);
  // const totalPrepMinutes = prepHours * 60 + prepMinutes;

  const handleCall = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-lg shadow-2xl p-6 w-96 sm:w-[617px]">
      <div>
        <p className="text-gray-500 dark:text-[#BCBCBC] text-base font-normal">
          Order #{order?.id}
        </p>
        <p className=" text-lg sm:text-xl font-medium mb-4">
          We have recieved your order
        </p>

        {track?.courier_orders?.length > 0 && (
          <div className="mt-6 mb-6 flex gap-3 w-full justify-between items-center">
            {/* <p className="text-gray-500 dark:text-[#BCBCBC] text-base font-normal mb-2">
              Your rider details:
            </p> */}
            <div className="flex gap-3 items-center">
              <img
                src={
                  track?.courier_orders?.[0]?.courier?.courier_picture || PIMAGE
                }
                alt="courier_picture"
                className="w-[52px] h-[52px] object-cover rounded-lg"
              />
              <div>
                <p className="text-gray-500 dark:text-[#BCBCBC] text-sm font-normal">
                  Rider details
                </p>
                <p className="capitalize dark:text-white text-lg font-semibold">
                  {track?.courier_orders?.[0]?.courier?.courier_name}
                </p>
              </div>
            </div>

            <Button.Primary
              title={"Call Rider"}
              type="button"
              onClick={() =>
                handleCall(track?.courier_orders?.[0]?.courier?.courier_phone)
              }
            />
          </div>
        )}

        <div className="border-b-2 dark:border-[#505050]"></div>

        <div className="flex justify-between text-lg sm:text-xl font-medium mt-6 mb-6">
          <div className="flex">
            <img src={ShippedIcon} alt="refresh icon" className="mr-2" />
            {/* If the order has been assigned to a courier, show the courier status, else, show the order status */}
            {track?.courier_orders?.length > 0 ? (
              <p
                className={`${order?.status === "shipped"
                  ? "text-[#046ECF]"
                  : "text-primary"
                  } text-lg`}
              >
                {track?.courier_orders?.[0]?.status}
              </p>
            ) : (
              <p
                className={`${order?.status === "shipped"
                  ? "text-[#046ECF]"
                  : "text-primary"
                  } text-lg`}
              >
                {order?.status}
              </p>
            )}
          </div>
          <p>
            {moment(order?.created_at).format("HH:mm")} -
            {moment(order?.created_at)
              // .add(totalPrepMinutes + extraMinutes, "minutes")
              .add(extraMinutes, "minutes")
              .format("HH:mm")}
          </p>
        </div>

        {/* {track?.courier_orders?.length > 0 && (
          <div className="mt-6 mb-6">
            <p className="text-gray-500 dark:text-[#BCBCBC] text-base font-normal mb-2">
              Your rider details:
            </p>
            <div className="flex">
              <img
                src={
                  track?.courier_orders?.[0]?.courier?.courier_picture || PIMAGE
                }
                alt="courier_picture"
                className="mr-2 w-11 h-11 rounded-full"
              />
              <div>
                <p className="capitalize">
                  {track?.courier_orders?.[0]?.courier?.courier_name}
                </p>
                <p>{track?.courier_orders?.[0]?.courier?.courier_phone}</p>
              </div>
            </div>
          </div>
        )} */}

        <div className="flex justify-between text-lg sm:text-xl font-medium mb-3">
          <div>
            <p className="text-gray-500 dark:text-[#BCBCBC] text-base font-normal">
              Estimated delivery:
            </p>
            {/* <p>
              {extraMinutes}-{Math.round(totalPrepMinutes + extraMinutes)} mins
            </p> */}
            <p>
              {extraMinutes} mins
            </p>
          </div>

          <div className="text-right">
            <p className="text-gray-500 dark:text-[#BCBCBC] text-base font-normal">
              Delivery Code:
            </p>
            <p>{track?.courier_orders?.[0]?.short_code ?? "--"}</p>
          </div>
        </div>
        <div className="border-b-2 dark:border-[#505050]"></div>
        <div className="py-4">
          <p className="text-gray-500 dark:text-[#BCBCBC] text-base font-normal mt-1">
            To:
          </p>
          <p className="sm:text-xl text-lg font-normal ">
            {order?.recipient_address}, {order?.recipient_city}
          </p>
        </div>
      </div>
    </div>
  );
};

Card.OrderDetails = ({ order }) => {
  return (
    <div className="w-96 sm:w-[617px]">
      <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-4 sm:px-8 mt-6">
        <div className="border-b border-[#E4E4F3] dark:border-[#505050] py-3 mb-4 flex justify-between items-center">
          <h3 className="text-lg font-medium">Order Details</h3>
        </div>

        {order?.order_items?.length > 0 &&
          order?.order_items?.map((product, i) => (
            <div key={i}>
              <div className="flex justify-between items-start mb-5">
                <div className="flex">
                  <span className="w-6 mr-3 sm:mr-10">{product.quantity}x</span>
                  <div>
                    <div>
                      <p className="mb-1">{product?.product_name}</p>
                      {product?.product_preparation_time && (() => {
                        const [h, m] = product.product_preparation_time.split(":").map(Number);
                        const totalMins = h * 60 + m;
                        return (
                          <div className="bg-[#F0EFEC] w-fit px-2 rounded-[8px]">
                            <span className="text-sm text-[#FFA927]">
                              *Prep-time: {totalMins} mins*
                            </span>
                          </div>
                        );
                      })()}
                    </div>
                    {product?.product_attributes?.length > 0 &&
                      product?.product_attributes?.map((attr, i) => (
                        <p key={i} className="text-sm text-[#676565]">
                          {attr.quantity}x {attr?.name} - NGN {attr.amount}
                        </p>
                      ))}
                  </div>
                </div>
                <p>NGN {product?.product_amount}</p>
              </div>
            </div>
          ))}
      </div>

      <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-4 sm:px-8 mt-6">
        <div className="flex justify-between items-center py-2">
          <span>Subtotal</span>
          <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
            ₦{numberWithCommas(order?.order_sub_amount)}
          </span>
        </div>
        <div className="flex justify-between items-center py-2">
          <span>Delivery fee</span>
          <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
            ₦{numberWithCommas(order?.order_delivery_fee)}
          </span>
        </div>
        <div className="flex justify-between items-center py-2">
          <span>Service fee</span>
          <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
            ₦{numberWithCommas(order?.order_service_fee)}
          </span>
        </div>
        <div className="flex justify-between items-center py-2">
          <span>Insurance fee</span>
          <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
            ₦{numberWithCommas(order?.order_insurance_fee)}
          </span>
        </div>
        <div className="flex justify-between items-center py-2">
          <span>Tax fee</span>
          <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
            ₦{numberWithCommas(order?.order_tax_fee)}
          </span>
        </div>
        <div className="flex justify-between items-center py-2">
          <span>Discount</span>
          <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
            ₦{numberWithCommas(order?.order_discount)}
          </span>
        </div>
        <div className="flex justify-between items-center py-2 border-t-2 border-[#EAEAEA] dark:border-[#505050]">
          <span>Total</span>
          <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
            ₦{numberWithCommas(order?.order_amount)}
          </span>
        </div>
      </div>
    </div>
  );
};

Card.FoodPackage = ({ data, className, isDarkMode }) => {
  const onImageError = (e) => {
    e.target.src = isDarkMode ? DarkStore : Restaurant;
  };
  return (
    <div
      className={
        "w-full rounded-lg cursor-pointer relative overflow-hidden" + className
      }
    >
      <Link to={`/food-package/customise/${data?.id}`}>
        <img
          className="rounded-t-lg w-full h-48  object-cover"
          src={
            data?.package_pictures?.length > 0
              ? data?.package_pictures?.[0]
              : isDarkMode
                ? DarkStore
                : Restaurant
          }
          onError={onImageError}
          alt="food-package"
        />

        <div className="p-5 border bg-white dark:bg-[#121212] rounded-b-xl">
          <h5 className="mb-2 text-xl font-bold tracking-tight text-black dark:text-white">
            {data?.package_name}
          </h5>

          <div className="">
            <p className="mb-0 text-sm text-[#BCBCBC]">
              Type: <span className="ml-1">Food Package</span>
            </p>
            <p className="mb-0 text-sm text-black dark:text-[#BCBCBC]">
              Expires:{" "}
              <span className="text-primary-500 font-bold ml-1">
                {moment(data?.package_end_date).format("DD/MM/YYYY")}
              </span>
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default Card;
